import Hero from '@components/Hero/Hero'
import ServicesPreview from '@components/ServicesPreview/ServicesPreview'
import styles from './Home.module.css'

function daysUntil(target) {
    const now = new Date()
    now.setHours(0, 0, 0, 0)
    return Math.max(0, Math.ceil((target - now) / (1000 * 60 * 60 * 24)))
}

const LAUNCHES = [
    {
        id: 'causacion',
        targetDate: new Date(Date.now() + 15 * 86400000),
        icon: '⚡',
        title: 'Causación Electrónica',
        headline: '¡El futuro del cumplimiento tributario!',
        description: 'Automatización completa de la causación electrónica. Generación automática de archivos, validaciones en tiempo real y cumplimiento DIAN sin esfuerzo.',
        gradient: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 50%, #ffc93c 100%)',
        glowColor: 'rgba(255, 107, 53, 0.4)',
        badge: '⚡ ¡PRÓXIMAMENTE!',
        badgeGradient: 'linear-gradient(90deg, #ff6b35, #f7931e)',
        isHighlight: true,
    },
]

function Home() {
    return (
        <div className={styles.home}>
            <Hero />
            <ServicesPreview />

            {/* Próximos Lanzamientos */}
            <div className={styles.launchesSection}>
                <div className={styles.container}>
                    <h2 className={styles.sectionTitle}>🚀 Próximamente en Ingconia</h2>
                    <div className={styles.launchGrid}>
                        {LAUNCHES.map(launch => {
                            const days = daysUntil(launch.targetDate)
                            const pct  = Math.max(8, 100 - days * 9)
                            return (
                                <div
                                    key={launch.id}
                                    className={`${styles.launchCard} ${launch.isHighlight ? styles.highlight : ''}`}
                                    style={{ '--glow': launch.glowColor }}
                                >
                                    <div className={styles.launchCardBg} style={{ background: launch.gradient }} />
                                    <span className={styles.launchBadge} style={{ backgroundImage: launch.badgeGradient }}>
                                        {launch.badge}
                                    </span>

                                    <div className={styles.countdownBlock}>
                                        <div className={styles.countdownRing} style={{ backgroundImage: launch.gradient }}>
                                            <span className={styles.countdownNum}>{days}</span>
                                        </div>
                                        <div className={styles.countdownMeta}>
                                            <span className={styles.countdownDays}>
                                                {days === 1 ? 'DÍA' : 'DÍAS'}
                                            </span>
                                            <span className={styles.countdownSub}>para el lanzamiento</span>
                                        </div>
                                    </div>

                                    <div className={styles.launchIcon}>{launch.icon}</div>
                                    <h3 className={styles.launchTitle}>{launch.title}</h3>
                                    <p className={styles.launchHeadline}>{launch.headline}</p>
                                    <p className={styles.launchDescription}>{launch.description}</p>

                                    <div className={styles.progressTrack}>
                                        <div
                                            className={styles.progressFill}
                                            style={{ backgroundImage: launch.gradient, width: `${pct}%` }}
                                        />
                                    </div>
                                    <p className={styles.progressLabel}>En desarrollo — ¡muy pronto!</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
